import { FormField, FormFieldProps } from './field'

import { TimePicker } from '@components/time-picker'
import { TimePickerProps } from 'types/ui/calendar'

export type TimeFieldProps = Omit<FormFieldProps<TimePickerProps>, 'component'>

export function TimeField(props: TimeFieldProps) {
  return <FormField {...props} component={TimePicker} />
}
